import React from "react";
import { useSelector } from "react-redux";
import DataTable from "src/components/Table";
import { useIsMobile } from "src/hooks/useIsMobile";
import { Ticket } from "src/types";
import { tableHeaders } from "../constant";
import ClientListItem from "./ClientListItem";
import ClientTableRow from "./ClientTableRow";
import { getIsTicketsLoading, getTickets } from "src/redux/selectors/resources";
import styled from "styled-components";

const ClientTicketsWrapper = () => {
  const isTicketsLoading = useSelector(getIsTicketsLoading);
  const tickets = useSelector(getTickets);

  const { isMobile } = useIsMobile();

  if (isMobile) {
    return (
      <>
        {tickets.map((ticket: Ticket) => (
          <ClientListItem ticket={ticket} key={ticket.wonum} />
        ))}
      </>
    );
  }
  // Original return — uncomment and remove the TableSizer block below to revert column widths:
  // return (
  //   <DataTable isLoading={isTicketsLoading} headers={tableHeaders}>
  //     {tickets?.map((ticket: Ticket) => <ClientTableRow key={ticket.wonum} ticket={ticket} />)}
  //   </DataTable>
  // );
  return (
    <TableSizer>
      <DataTable isLoading={isTicketsLoading} headers={tableHeaders}>
        {tickets?.map((ticket: Ticket) => (
          <ClientTableRow key={ticket.wonum} ticket={ticket} />
        ))}
      </DataTable>
    </TableSizer>
  );
};

export default ClientTicketsWrapper;

/* Scoped column widths for the 7-column client table:
   1. No.               8%
   2. Date Created     13%
   3. Location         14%
   4. Work Request Name 28%
   5. Service Type     17%
   6. Priority Level   10%
   7. Status           10%
*/
const TableSizer = styled.div`
  table {
    table-layout: fixed;
  }
  table th:nth-child(1),
  table td:nth-child(1) {
    width: 8%;
  }
  table th:nth-child(2),
  table td:nth-child(2) {
    width: 13%;
  }
  table th:nth-child(3),
  table td:nth-child(3) {
    width: 14%;
  }
  table th:nth-child(4),
  table td:nth-child(4) {
    width: 28%;
  }
  table th:nth-child(5),
  table td:nth-child(5) {
    width: 17%;
  }
  table th:nth-child(6),
  table td:nth-child(6) {
    width: 10%;
  }
  table th:nth-child(7),
  table td:nth-child(7) {
    width: 10%;
  }
`;
